"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schemaComponents_1 = require("@/schemaComponents");
exports.default = ({ projectId }) => {
    return (0, schemaComponents_1.mergeSchema)({ schemaType: "object", properties: [] }, [
        // {
        //   title: "翻訳ファイルID",
        //   propertyName: "segmentId",
        //   schema: {
        //     schemaType: "text",
        //     required: true,
        //   },
        // },
        {
            title: "翻訳ファイル名",
            propertyName: "segmentName",
            schema: {
                schemaType: "text",
            },
        },
        ...schemaComponents_1.timestampsProperties,
        {
            title: "翻訳文検索",
            propertyName: "aiSearch",
            schema: {
                schemaType: "textIntl",
                required: true,
            },
        },
    ]);
};
